var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 12.5C22 18.024 17.523 22.5 12 22.5C6.477 22.5 2 18.024 2 12.5C2 6.978 6.477 2.5 12 2.5C17.523 2.5 22 6.978 22 12.5Z",
    fill: "#FF0909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 15.4287C12.4871 15.4287 12.8791 15.8217 12.8791 16.3037C12.8791 16.7857 12.4871 17.1787 12.0041 17.1787C11.5191 17.1787 11.1241 16.7857 11.1241 16.3037C11.1241 15.8217 11.5151 15.4287 11.9941 15.4287ZM11.9941 7.83594C12.4761 7.83594 12.8691 8.22894 12.8691 8.71094V13.1309C12.8691 13.6129 12.4761 14.0059 11.9941 14.0059C11.5121 14.0059 11.1191 13.6129 11.1191 13.1309V8.71094C11.1191 8.22894 11.5121 7.83594 11.9941 7.83594Z",
    fill: "#FF0909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningCircleRed);
export default __webpack_public_path__ + "static/media/icon-warning-circle-red.8ffc4f743aeb0ad76cc59d7f94f87b26.svg";
export { ForwardRef as ReactComponent };